import { Loading } from '@shape-ds/components';
import ButtonLink from 'components/ExternalLink/ExternalLink';
import { ASSET_PAGE } from 'config/paths';
import { useAssetsByWorkspaceQuery } from 'queries/assets/queries';
import React, { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormAutocomplete } from 'ui/FormComponents';
import { getOptionsFromAssetChildren } from '../../helpers';

interface ConditionDeviationAssetFieldProps {
  assets?: { name?: string; id: string }[];
  selectedAsset?: string;
}

const ConditionDeviationAssetField: React.FC<ConditionDeviationAssetFieldProps> = ({
  assets,
  selectedAsset,
}) => {
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  const { data, isFetching } = useAssetsByWorkspaceQuery();

  const equipmentOptions = useMemo(
    () => getOptionsFromAssetChildren(data?.items[0].children, assets),
    [data, assets],
  );

  const selectedAssetOption = useMemo(
    () => equipmentOptions.find((option) => option.id === selectedAsset),
    [selectedAsset, equipmentOptions],
  );

  useEffect(() => {
    setValue('asset_id', selectedAsset);
  }, [selectedAsset]);

  if (isFetching) return <Loading />;

  return (
    <div className="pb-4 four-collumns">
      <div className={`asset-id-field ${selectedAssetOption ? 'with-asset' : ''}`}>
        <FormAutocomplete
          name="asset_id"
          isRequired
          label={
            selectedAsset
              ? t('components:ConditionDeviation.asset')
              : t('components:ConditionDeviation.newAsset')
          }
          options={equipmentOptions}
          defaultValue={selectedAsset}
          placeHolder={t('components:ConditionDeviation.placeholders.assetName')}
        />
      </div>
      {selectedAssetOption && (
        <ButtonLink
          url={ASSET_PAGE(selectedAssetOption.id)}
          label={t('components:ConditionDeviation.openAsset')}
          isExternalLink
        />
      )}
    </div>
  );
};

export default ConditionDeviationAssetField;
